import { createApp, ref } from 'vue';
// 别删 languages
import languages from '@/assets/lang/index.js';
import { initLib, initGlobal, debounceDirective, throttleDirective } from 'platform-lib-app';
import { setupStore } from '@/store/pinia';
import router from './router';
import { setupRouterGuard } from '@/router/guards.js';
import { initApp } from '@/utils/common/appInit';
import App from './App.vue';
import packageJson from '../package.json';

// cotti 咖啡全局样式
import '@/assets/styles/global.scss';
// import 'vant/lib/index.css';
import '@cotti/global/dist/style.css';
// ar样式
import '@/assets/lang/ar/ar.scss';

const app = createApp(App);

// 设置高德地图安全秘钥
if (['test', 'pre', 'prod'].includes(import.meta.env.VITE_APP_ENV)) {
  window._AMapSecurityConfig = {
    serviceHost: `${import.meta.env.VITE_APP_URL}/_AMapService`,
  };
}

app.use(router);
setupRouterGuard(router);
setupStore(app);

window.APP_VISIBLE = ref(false);
initLib(app, import.meta.env).then(() => {
  // 确保语言包加载完成
  window.APP_VISIBLE.value = true;
});

initGlobal({
  app,
  readLoacal: true,
});

initApp(app);

debounceDirective(app);
throttleDirective(app);
app.mount('#app');
